"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternal = isExternal;
exports.validUsername = validUsername;
exports.validURL = validURL;
exports.validLowerCase = validLowerCase;
exports.validUpperCase = validUpperCase;
exports.validAlphabets = validAlphabets;
exports.validEmail = validEmail;
exports.isString = isString;
exports.isArray = isArray;
exports.isMoney = isMoney;
exports.check_num = check_num;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.to-string");

var _user = require("../api/user");

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
/**
 * @param {string} url
 * @returns {Boolean}
 */


function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} email
 * @returns {Boolean}
 */


function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }

  return false;
}
/**
 * @param {Array} arg
 * @returns {Boolean}
 */


function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }

  return Array.isArray(arg);
}

function isMoney(newVal) {
  var needMinus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var numberOfDecimal = arguments.length > 2 ? arguments[2] : undefined;
  // Form initiated
  if (newVal === '') return true; // Starter variable

  var index;
  var lastChar;

  try {
    index = newVal.indexOf(".");
    lastChar = newVal.charAt(newVal.length - 1);
  } catch (e) {
    return true;
  } // check decimal


  if (lastChar === '.' && index === newVal.length - 1 && newVal.length > 1) return true;

  if (needMinus) {
    // check is minus sign at the beginning
    if (lastChar === '-' && newVal.length === 1) return true;
  } // check is float


  var isNum = parseFloat(newVal);

  if (isNaN(isNum) || isNum.toString().length !== newVal.length && lastChar !== '0') {
    return false;
  }

  if (isNaN(numberOfDecimal) || numberOfDecimal == null) {
    numberOfDecimal = 2;
  } // check number of decimal


  if (index === -1) return true;
  return newVal.length - index - 1 <= numberOfDecimal;
}

function check_num(newVal) {
  if (typeof newVal == "number") {
    return newVal;
  }

  var license_num = newVal;
  license_num = license_num.replace(/[^\d]/g, ''); // 清除“数字”和“.”以外的字符

  if (license_num.indexOf('.') < 0 && license_num != '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    license_num = parseInt(license_num);
  }

  return license_num;
}